import { setCookie, getCookie } from '../functions/cookies.js';
import { openPopup } from '../functions/popups'; 

export const newsletterCTA = () => {
    
	if (document.querySelector('.popup-newsletter-cta')) {
		
	    if (!getCookie('newsletterPopupClosed')) { // Check if cookie is not set
	        setTimeout(function() {
	            document.querySelector('.popup-newsletter-cta').style.display = 'flex'; // Show the popup
	        }, 4000); // Wait 4 seconds before showing
	    }

	    // Close popup when "subscribe" button is clicked
	    document.querySelector('.js-newsletter-cta-trigger').addEventListener('click', function() {
	        setCookie('newsletterPopupClosed', 'true', 7); // Set cookie for 7 days
	        openPopup('#newsletter');
	        document.querySelector('.popup-newsletter-cta').style.display = 'none';
	    });

	    // Close popup when close button (image) is clicked
	    document.querySelector('.js-close-popup-newsletter-cta-modal').addEventListener('click', function() {
	        setCookie('newsletterPopupClosed', 'true', 7); // Set cookie for 7 days
	        document.querySelector('.popup-newsletter-cta').style.display = 'none';
	    });
	}
}